"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.explorerColumnPresetGroupsDefault = void 0;
var ExplorerColumnPresetType_1 = require("Modules/explorers/types/ExplorerColumnPresetType");
var parseColumnNamesToColumnPresetData_1 = require("Modules/explorers/utils/parseColumnNamesToColumnPresetData");
var columns = [
    "name",
    "access",
    "members",
    "experts",
    "leaders",
    "socialExplorer.modulesJoined",
    "created",
];
exports.explorerColumnPresetGroupsDefault = (0, parseColumnNamesToColumnPresetData_1.parseColumnNamesToColumnPresetData)(columns, ExplorerColumnPresetType_1.ExplorerColumnPresetType.groups);
